import React from 'react';
import classnames from 'classnames';
import { map } from 'lodash';

// local dependencies
import { WIDGET_NAMES } from 'constants/entity-names';
import { withHeaderAndFooter } from 'ui/hoc/withHeaderAndFooter';
import { widgetError as WidgetError } from 'ui/views/widgets/widgetError';
import { CallControlWidget } from 'ui/containers/CallControlWidget';
import { OffCallControlWidget } from 'ui/containers/OffCallControlWidget';
import { CallManagementListsWidget } from 'ui/containers/CallManagementListsWidget';
import { CallAuthorizationFlowWidget } from 'ui/containers/CallAuthorizationFlowWidget';
import { MemberManagementWidget } from 'ui/containers/MemberManagementWidget';
import { heartBeatPreloader as HeartBeatPreloader } from 'ui/views/generic/heartBeatPreloader';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { MemberOrderDetail } from 'ui/containers/MemberOrderDetail';
import { MemberClaimDetail } from 'ui/containers/MemberClaimDetail';
import { MemberPrescriptionDetail } from 'ui/containers/MemberPrescriptionDetail';
import { Checkout } from 'ui/containers/Checkout';
import { DrugSearch } from 'ui/containers/DrugSearch';
import { CallWidgetItemDetail } from 'ui/containers/CallWidgetItemDetail';
import { ActionWidgetItemDetail } from 'ui/containers/ActionWidgetItemDetail';
import { EnrollToEpost } from 'ui/containers/EnrollToEpost';
import { ReactivateEpostWidget } from 'ui/containers/ReactivateEpostWidget';
import { MemberDetailsPayBalanceStepsWidget } from 'ui/containers/MemberDetailsPayBalanceStepsWidget';
import { ToDoItemDetailWidget } from 'ui/containers/ToDoItemDetailWidget';
import { RxEnableAutoRefill } from 'ui/containers/RxEnableAutoRefill';
import { MemberAlertsListing } from 'ui/containers/MemberAlertsListing';
import { PriorAuthDetail } from 'ui/containers/PriorAuthDetail';

// widget views
const WIDGET_VIEWS = {
    [ WIDGET_NAMES.OFF_CALL_CONTROL ]: OffCallControlWidget,
    [ WIDGET_NAMES.CALL_CONTROL ]: CallControlWidget,
    [ WIDGET_NAMES.CALL_MANAGEMENT_LISTS ]: CallManagementListsWidget,
    [ WIDGET_NAMES.CALL_AUTHORIZATION_FLOW ]: CallAuthorizationFlowWidget,
    [ WIDGET_NAMES.MEMBER_MANAGEMENT ]: MemberManagementWidget,
    [ WIDGET_NAMES.ORDER_DETAILS ]: MemberOrderDetail,
    [ WIDGET_NAMES.CLAIM_DETAILS ]: MemberClaimDetail,
    [ WIDGET_NAMES.PRESCRIPTION_DETAILS ]: MemberPrescriptionDetail,
    [ WIDGET_NAMES.CHECKOUT_NEW_ORDER ]: Checkout,
    [ WIDGET_NAMES.CHECKOUT_RE_ORDER ]: Checkout,
    [ WIDGET_NAMES.CHECKOUT_EDIT_ORDER ]: Checkout,
    [ WIDGET_NAMES.DRUG_SEARCH ]: DrugSearch,
    [ WIDGET_NAMES.CALL_DETAIL ]: CallWidgetItemDetail,
    [ WIDGET_NAMES.ACTION_DETAIL ]: ActionWidgetItemDetail,
    [ WIDGET_NAMES.ENROLL_TO_EPOST ]: EnrollToEpost,
    [ WIDGET_NAMES.REACTIVATE_EPOST ]: ReactivateEpostWidget,
    [ WIDGET_NAMES.PAY_BALANCE ]: MemberDetailsPayBalanceStepsWidget,
    [ WIDGET_NAMES.TO_DO_DETAIL ]: ToDoItemDetailWidget,
    [ WIDGET_NAMES.ENABLE_AUTO_REFILL ]: RxEnableAutoRefill,
    [ WIDGET_NAMES.MEMBER_ALERTS_LISTING ]: MemberAlertsListing,
    [ WIDGET_NAMES.PRIOR_AUTH_DETAILS ]: PriorAuthDetail
};

/*******************************/

// success widget view
const _dashboardSuccess = ( props ) => {
    return (
        <div className='ui-dashboard'>
            {
                map( props.widgets, widget => {

                    // get widget view
                    const WidgetView = WIDGET_VIEWS[ widget.name ];

                    // widget class name
                    const widgetClassName = classnames( 'ui-dashboard__widget', `ui-dashboard__widget--name-${ widget.name }`, {
                        'ui-dashboard__widget--inactive': widget.inactive,
                    } );

                    return (
                        <div key={ widget.name } className={ widgetClassName }>
                            <WidgetView widget={ widget } />
                        </div>
                    );
                } )
            }
        </div>
    );
};

// set display name
_dashboardSuccess.displayName = '_dashboardSuccess';

// set default props
_dashboardSuccess.defaultProps = {
    widgets: [],
};

// prop types
_dashboardSuccess.propTypes = {};

// view with header and footer
const dashboardSuccess = withHeaderAndFooter( _dashboardSuccess );


/*******************************/


// preloader widget view
const dashboardPreloader = () => {
    return (
        <div className='ui-dashboard-preloader'>
            <HeartBeatPreloader className='ui-dashboard-preloader__animation' />
        </div>
    );
};

// set display name
dashboardPreloader.displayName = 'dashboardPreloader';

// set default props
dashboardPreloader.defaultProps = {};

// prop types
dashboardPreloader.propTypes = {};


/*******************************/


// error widget view
const dashboardError = () => {
    return (
        <div className='ui-dashboard-error'>
            <div className='ui-dashboard-error__widget'>
                <WidgetError size='large'/>
            </div>
        </div>
    );
};

// set display name
dashboardError.displayName = 'dashboardError';

// set default props
dashboardError.defaultProps = {};

// prop types
dashboardError.propTypes = {};


/*******************************/


/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { dashboard as Dashboard } from 'ui/views/layouts/dashboard';
 *
 * // render
 * <Dashboard propName='propValue'/>
 */
export const dashboard = withNetworkState( dashboardPreloader, dashboardSuccess, dashboardError );
